import { render, staticRenderFns } from "./activity-reply-message.vue?vue&type=template&id=2bc24f63"
import script from "./activity-reply-message.vue?vue&type=script&lang=js"
export * from "./activity-reply-message.vue?vue&type=script&lang=js"
import style0 from "./activity-reply-message.vue?vue&type=style&index=0&id=2bc24f63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports